import { message } from "antd";
import { useContext, useState } from "react";
import styles from "./styles.module.css";
import { CheckCircleOutlined } from "@ant-design/icons";
import { CustomButton } from "..";
import { AuthContext } from "../../context";

export const WitnessPicker = ({
  formData,
  setFormData,
  onClose,
  users,
}: any) => {
  const { user } = useContext(AuthContext);
  const confirmedStaffs = users?.filter(
    (x: any) =>
      x.hcm.employmentType?.toLowerCase() === "permanent employee" &&
      x.isActive === true
  );
  const [searchQuery, setSearchQuery] = useState("");
  const filteredWitnesses = confirmedStaffs.filter(
    (witness: any) =>
      witness.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      witness.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      witness.hcm.department.toLowerCase().includes(searchQuery.toLowerCase())
  );

  console.log("users", confirmedStaffs);

  const toggleWitness = (witnessData: { email: string; name: string }) => {
    setFormData((prev: any) => {
      const currentWitnesses = prev.witnesses || [];
      if (
        currentWitnesses
          .map((curr: any) => curr.email)
          .includes(witnessData?.email)
      ) {
        return {
          ...prev,
          witnesses: currentWitnesses.filter(
            (data: any) => data.email !== witnessData.email
          ),
        };
      } else {
        if (currentWitnesses.length >= 2) {
          message.warning("Maximum 2 witnesses allowed");
          return prev;
        }
        return { ...prev, witnesses: [...currentWitnesses, witnessData] };
      }
    });
  };

  const isSelected = (email: string) =>
    formData.witnesses?.map((w: any) => w.email).includes(email);

  return (
    <>
      <div>
        <div className={styles.witnessCounter}>
          Selected: {formData.witnesses?.length || 0} / 2 Witnesses
        </div>

        <input
          type="text"
          placeholder="Search by name, email, or department..."
          className={styles.searchInput}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        {filteredWitnesses?.length === 0 ? (
          <div className={styles.emptyState}>
            <div className={styles.emptyStateIcon}>🔍</div>
            <p>No witnesses found matching your search</p>
          </div>
        ) : (
          filteredWitnesses?.map((witness: any) => (
            <div
              key={witness._id}
              className={`${styles.witnessCard} ${
                isSelected(witness.email) ? styles.witnessCardSelected : ""
              }`}
              onClick={() =>
                toggleWitness({ email: witness.email, name: witness.name })
              }
            >
              <div className={styles.witnessCardHeader}>
                <div>
                  <div className={styles.witnessName}>{witness.name}</div>
                  <div className={styles.witnessInfo}>
                    {witness.hcm.jobLevel} • {witness.hcm.department}
                  </div>
                  <div className={styles.witnessInfo}>{witness.email}</div>
                </div>
                {isSelected(witness.email) && (
                  <div className={styles.selectedBadge}>
                    <CheckCircleOutlined /> Selected
                  </div>
                )}
              </div>
            </div>
          ))
        )}

        <div className={styles.actionButtons}>
          <CustomButton
            type="primary"
            block
            disabled={(formData.witnesses?.length || 0) !== 2}
            onClick={onClose}
          >
            Confirm Witnesses ({formData.witnesses?.length || 0}/2)
          </CustomButton>
        </div>
      </div>
    </>
  );
};
